

import Vue from 'vue'
import App from './App'
import router from './router'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import moment from 'moment'
Vue.use(Antd)
localStorage.token = '';
Vue.config.productionTip = false
Vue.use(ToastPlugin)
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.use(ToastPlugin, {position: 'top'})
import echarts from 'echarts'
import store from './store'

Vue.prototype.$echarts = echarts
Vue.filter('dateFormat', function (value, fmt) {
let getDate = new Date(value);
let o = {
'M+': getDate.getMonth() + 1,
'd+': getDate.getDate(),
'h+': getDate.getHours(),
'm+': getDate.getMinutes(),
's+': getDate.getSeconds(),
'q+': Math.floor((getDate.getMonth() + 3) / 3),
'S': getDate.getMilliseconds()
};
if (/(y+)/.test(fmt)) {
fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
}
for (let k in o) {
if (new RegExp('(' + k + ')').test(fmt)) {
fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
}
}
return fmt;
});
Vue.filter('dateFormatLong', function (dataStr, pattern) {
if (!dataStr) {
return '--'
}
return moment(dataStr).format(pattern)
})
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js